export const PRICES = {
  MAX_FIX_PRICE: 10000001,
};
